/**
 * Handle the behavior of the newsletter signup.
 */
const NewsletterSignup = {
	_init: () => {
		document.addEventListener('DOMContentLoaded', NewsletterSignup._ready);
	},
	_ready: () => {
		const newsletterSignup = document.getElementById('newsletter');
		newsletterSignup.addEventListener('submit', NewsletterSignup._newsletterSignupSubmitHandler);

		const newsletterRes = document.querySelector('.newsletter-field-res');
		newsletterRes.addEventListener('click', NewsletterSignup._newsletterCloseHandler);
	},
	_newsletterSignupSubmitHandler: async (e) => {
		e.preventDefault();
		let fetchurl = new URL(ajaxurl);
		
		const form = new FormData(e.currentTarget);
		form.append('action', 'newsletter_signup');
		
		for (let [key, value] of form.entries()) {
			console.log(`${key}: ${value}`);
		}
		
		// debugger;
		let res = await fetch(fetchurl, {
			method: 'POST',
			body: form,
		})
		res = await res.json();

		if (res.status === 400 || res.status === 500) {
			const newsletterInput = document.querySelector('.newsletter-field-input');
			newsletterInput.style.display = 'none';
			const newsletterButton = document.querySelector('.newsletter-field-button');
			newsletterButton.style.display = 'none';
			const errorField = document.querySelector('.newsletter-field-res.error');
			errorField.style.display = 'flex';
		} else if (res.status === 200) {
			const newsletterInput = document.querySelector('.newsletter-field-input');
			newsletterInput.style.display = 'none';
			const newsletterButton = document.querySelector('.newsletter-field-button');
			newsletterButton.style.display = 'none';
			const successField = document.querySelector('.newsletter-field-res.success');
			successField.style.display = 'flex';
		}

		console.log(res);
	},
	_newsletterCloseHandler: (e) => {
		debugger;
		
		const newsLetter = document.getElementById('newsletter');
		newsLetter.reset();

		const newsletterRes = document.querySelector('.newsletter-field-res');
		newsletterRes.style.removeProperty('display');
		const newsletterResClose = document.querySelector('.newsletter-field-res-close');
		newsletterResClose.style.removeProperty('display');

		const newsletterInput = document.querySelector('.newsletter-field-input');
		newsletterInput.style.removeProperty('display');
		const newsletterButton = document.querySelector('.newsletter-field-button');
		newsletterButton.style.removeProperty('display');
	}
}
NewsletterSignup._init();